import { Box, Typography } from "@mui/material";

const LabelledBox = ({ label, children, sx }) => {
    return (
        <Box 
            sx={{
                position: 'relative',
                border: '1px solid black',
                borderRadius: '4px',
                padding: '10px',
                mt: '8px',
                borderColor: 'rgba(0, 0, 0, 0.23)',
                ...sx
            }}
        >
            <Typography
                component="span"
                sx={{
                    position: 'absolute',
                    top: '-9px',
                    left: '10px',
                    backgroundColor: 'white',
                    padding: '0 4px',
                    fontSize: '12px',
                    color: 'rgba(0, 0, 0, 0.4)',
                }}
            >
                {label}
            </Typography>
            {children}
        </Box>
    );
};

export default LabelledBox;